<template>
	<RouterLink
		:to="`/task/${task._id}`"
		class="task-card"
		:class="{
			'task-disabled': task.completed
		}"
	>
		<div v-if="task.completed" class="completed">Completed</div>

		<TaskCardIcon :icon="taskImage" />

		<div>{{ task.title }}</div>

		<div class="reward" :class="{ 'reward-disabled': props.task.completed }">
			<CrystalAmount :amount="task.reward" />
		</div>
	</RouterLink>
</template>

<script setup lang="ts">
import { RouterLink } from 'vue-router';
import type { ITaskDto } from '../hooks/useTask';
import TaskCardIcon from './ActivityIcon.vue';
import { computed } from 'vue';
import CrystalAmount from './CrystalAmount.vue';
import { TASK_ICON_BY_TYPE } from '../utils';

const props = defineProps<{
	task: ITaskDto;
}>();

const taskImage = computed(() => TASK_ICON_BY_TYPE[props.task.type]);
</script>

<style scoped>
.task-card {
	box-sizing: border-box;

	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	padding: 8px 12px;
	gap: 16px;

	background: linear-gradient(
		83.45deg,
		rgba(2, 122, 255, 0.05) -1.65%,
		rgba(248, 254, 255, 0.05) 52.48%,
		rgba(2, 122, 255, 0.05) 104.15%
	);
	border-radius: 16px;

	border: 1px solid rgba(255, 255, 255, 0.1);

	position: relative;
}

.task-disabled {
	background: rgba(255, 255, 255, 0.03);

	cursor: default;

	pointer-events: none;
}

.task-disabled > * {
	color: rgba(255, 255, 255, 0.4) !important;
}

.reward {
	border: 1px solid rgba(255, 255, 255, 0.03);

	background-color: #ffffff0d;

	color: #ffffff;

	font-family: Exo 2;
	font-size: 13px;
	font-weight: 600;
	line-height: 15.6px;
	text-align: left;
	text-underline-position: from-font;
	text-decoration-skip-ink: none;

	padding: 6px 8px 6px 8px;
	border-radius: 16px;

	display: flex;

	align-items: center;
}

.reward-disabled {
	background: rgba(255, 255, 255, 0.05);
}

.reward-disabled > * {
	color: rgba(255, 255, 255, 0.3) !important;
}

.completed {
	position: absolute;
	top: 0px;
	right: 16px;

	padding: 2px 6px;
	background: rgba(0, 73, 12, 0.5);
	border-radius: 0px 0px 4px 4px;

	font-family: 'Exo 2';
	font-style: normal;
	font-weight: 600;
	font-size: 10px;
	line-height: 12px;
	text-align: center;
	text-transform: uppercase;

	color: rgba(255, 255, 255, 0.5);
}
</style>
